import { ComboData } from "./ComboSimulador";

export const ComboRentabilidade: Array<ComboData> = [
  {
    Name: "0,5%",
    Value: "0.5"
  },
  {
    Name: "1,0%",
    Value: "1"
  },
  {
    Name: "1,5%",
    Value: "1.5"
  },
  {
    Name: "2,0%",
    Value: "2"
  },
  {
    Name: "2,5%",
    Value: "2.5"
  },
  {
    Name: "3,0%",
    Value: "3"
  },
  {
    Name: "3,5%",
    Value: "3.5"
  },
  {
    Name: "4,0%",
    Value: "4"
  },
  {
    Name: "4,5%",
    Value: "4.5"
  },
  {
    Name: "5,0%",
    Value: "5"
  }
];